import { apiAction, appendQuery } from 'client/redux/apiHelpers';

export const endpointLog = (types, query) => {
  return apiAction({
    endpoint: appendQuery('/api/endpoint/log', query),
    method: 'GET',
    types,
  });
};
